$(function() {


    $('a').on('click', function(e){
        var href = $(this).attr('href');
        if (href == '#gaOptout') {
            e.preventDefault();
            gaOptout();
            alert('Google Opt-Out-Cookie wurde gesetzt.');
        }
    });
});
